import type BookingServiceCategoryType from 'owa-service/lib/contract/BookingServiceCategoryType';
import type { BookingServiceCategory } from 'owa-graph-schema';
import type BookingServiceCategoryEnum from '../../constants/bookingServiceCategory';

const mapBookingServiceCategory = (
    bookingServiceCategory: BookingServiceCategory
): BookingServiceCategoryType | undefined => {
    switch (bookingServiceCategory) {
        case 'Scheduled':
            return 0;
        case 'OnDemand':
            return 1;
    }
    return;
};

export default mapBookingServiceCategory;
